import React, { lazy } from 'react';
import { Section } from './ui';
import { XCircle, CheckCircle2, TrendingUp, Users } from 'lucide-react';
export const Brands = () => {
  const brands = [{
    img: 'https://cdn.magicpatterns.com/uploads/oz1REHYvgBmsno2pwoNodQ/image.png',
    alt: 'Lomastore'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/9wyVySsbMoaSDdxPTzX8J7/image.png',
    alt: 'Moment Store'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/cVsHToiPTSsFwgFf5jbDnK/image.png',
    alt: 'iAccess Store'
  }];
  return <Section className="pt-8 pb-16" data-id="element-30">
      <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-31">
        <p className="text-lg md:text-xl font-medium text-zinc-400" data-id="element-32">
          Algunas de las marcas con las que trabajo hace más de 2 años aplicando
          este sistema de anuncios:
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-33">
        {brands.map((brand, i) => <div key={i} className="bg-zinc-900/50 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/[0.05] shadow-lg hover:border-blue-500/30 transition-colors" data-id="element-34">
            <img src={brand.img} alt={brand.alt} loading="lazy" className="w-full h-auto object-cover" data-id="element-35" />
          </div>)}
      </div>
    </Section>;
};
export const VideoShowcase = () => {
  return <Section className="bg-white/[0.02] border-y border-white/[0.05] backdrop-blur-sm" data-id="element-36">
      <div className="text-center mb-12 max-w-3xl mx-auto" data-id="element-37">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-38">
          Así se ve el sistema aplicado al rubro iPhone
        </h2>
        <p className="text-lg text-zinc-400" data-id="element-39">
          Videos simples, directos y pensados para generar conversaciones reales
          de venta.
        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-3xl mx-auto" data-id="element-40">
        {/* Video 1 */}
        <div className="relative aspect-[9/16] rounded-3xl overflow-hidden border border-white/[0.1] shadow-xl md:shadow-2xl bg-zinc-900" data-id="element-41">
          <video autoPlay muted loop playsInline preload="metadata" className="absolute inset-0 w-full h-full object-cover" data-id="element-42">
            <source src="https://cdn.magicpatterns.com/uploads/vggicj5TXQDZzjci1pCasi/iaccess-1-marzo_jwjNrUIG.mp4" type="video/mp4" data-id="element-43" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/80 via-transparent to-transparent pointer-events-none" data-id="element-44"></div>
        </div>
        {/* Video 2 */}
        <div className="relative aspect-[9/16] rounded-3xl overflow-hidden border border-white/[0.1] shadow-xl md:shadow-2xl bg-zinc-900" data-id="element-45">
          <video autoPlay muted loop playsInline preload="metadata" className="absolute inset-0 w-full h-full object-cover" data-id="element-46">
            <source src="https://cdn.magicpatterns.com/uploads/pbcaCSJUtdYPxR4EKankY2/iphone-17-pro-max-2_ohVHguby.mp4" type="video/mp4" data-id="element-47" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/80 via-transparent to-transparent pointer-events-none" data-id="element-48"></div>
        </div>
      </div>
    </Section>;
};
export const MarketingVideo = () => {
  return <Section data-id="element-49">
      <div className="grid md:grid-cols-2 gap-10 items-center max-w-5xl mx-auto" data-id="element-50">
        <div className="order-2 md:order-1 relative aspect-[9/16] max-w-[300px] mx-auto w-full rounded-3xl overflow-hidden border border-white/[0.1] shadow-xl md:shadow-2xl bg-zinc-900" data-id="element-51">
          <video autoPlay muted loop playsInline preload="metadata" className="absolute inset-0 w-full h-full object-cover" data-id="element-52">
            <source src="https://cdn.magicpatterns.com/uploads/pbcaCSJUtdYPxR4EKankY2/iphone-17-pro-max-2_ohVHguby.mp4" type="video/mp4" data-id="element-53" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/80 via-transparent to-transparent pointer-events-none" data-id="element-54"></div>
        </div>
        <div className="order-1 md:order-2 text-center md:text-left" data-id="element-55">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-emerald-500/10 mb-6" data-id="element-56">
            <Users className="w-6 h-6 text-emerald-500" data-id="element-57" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-58">
            Marketing que vende
          </h2>
          <p className="text-xl text-zinc-300 leading-relaxed" data-id="element-59">
            Aprendé a crear contenido y anuncios que no parezcan publicidad
            tradicional, pero que estén pensados para vender.
          </p>
        </div>
      </div>
    </Section>;
};
export const PainPoints = () => {
  const points = ['Querés empezar a vender iPhones pero no sabés por dónde arrancar.', 'No tenés stock propio y pensás que eso te impide empezar.', 'Tenés miedo de comprar mal y perder plata.', 'No sabés qué modelos conviene vender primero.', 'No sabés cómo conseguir proveedores.', 'Ves que otros venden iPhones, pero no entendés cómo entrar al negocio.', 'Publicás en Instagram y no te llegan clientes reales.', 'Te hablan curiosos, pero no personas con intención de comprar.', 'Querés aprender a vender por pedido antes de arriesgar tu plata.', 'Querés empezar con una estructura simple y realista.'];
  return <Section className="bg-white/[0.02] border-y border-white/[0.05] backdrop-blur-sm" data-id="element-60">
      <div className="text-center mb-12" data-id="element-61">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-62">
          Este curso es para vos si…
        </h2>
      </div>
      <div className="grid md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-63">
        {points.map((point, i) => <div key={i} className="flex items-start p-4 bg-zinc-900/50 backdrop-blur-sm md:backdrop-blur-md rounded-xl border border-white/[0.05] shadow-sm md:shadow-lg" data-id="element-64">
            <XCircle className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-65" />
            <p className="text-zinc-300" data-id="element-66">{point}</p>
          </div>)}
      </div>
      <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-67">
        <p className="text-xl md:text-2xl font-semibold text-blue-400" data-id="element-68">
          "El problema no es no tener stock. El problema es arrancar sin
          entender cómo se mueve el negocio."
        </p>
      </div>
    </Section>;
};
export const BeliefShift = () => {
  const steps = ['Primero entendés cómo funciona el negocio.', 'Después aprendés qué modelos mirar.', 'Después ves cómo vender por pedido.', 'Después aprendés a conseguir clientes.', 'Y recién ahí tomás mejores decisiones con tu plata.'];
  return <Section data-id="element-69">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-70">
        <div data-id="element-71">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-72">
            No necesitás arrancar comprando 10 iPhones
          </h2>
          <p className="text-lg text-zinc-400 leading-relaxed mb-6" data-id="element-73">
            Mucha gente cree que para empezar en este negocio necesita comprar
            varios equipos, tener local o invertir mucha plata desde el primer
            día. Pero la realidad es que podés empezar de forma más inteligente:
            entendiendo el mercado, vendiendo por pedido, trabajando con
            proveedores y aprendiendo a generar clientes antes de comprar mal.
          </p>
          <div className="space-y-4 mb-8" data-id="element-74">
            {steps.map((step, i) => <div key={i} className="flex items-center p-5 bg-zinc-900/50 backdrop-blur-sm md:backdrop-blur-md rounded-xl border border-white/[0.05] shadow-sm md:shadow-lg" data-id="element-75">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-emerald-500/10 mr-4 flex-shrink-0" data-id="element-76">
                  <CheckCircle2 className="w-5 h-5 text-emerald-500" data-id="element-77" />
                </div>
                <p className="text-zinc-200 font-medium" data-id="element-78">{step}</p>
              </div>)}
          </div>
          <div className="p-6 bg-blue-900/20 border border-blue-500/20 rounded-2xl" data-id="element-79">
            <p className="text-lg font-semibold text-blue-300" data-id="element-80">
              "La idea no es que salgas a invertir a ciegas. La idea es que
              aprendas cómo moverte."
            </p>
          </div>
        </div>
        <div className="relative h-[400px] md:h-full min-h-[300px] md:min-h-[400px] rounded-3xl overflow-hidden border border-white/[0.1] shadow-lg md:shadow-2xl" data-id="element-81">
          <div className="absolute top-4 left-4 z-10 bg-zinc-950/80 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.1] rounded-lg px-4 py-2 max-w-[80%]" data-id="element-82">
            <p className="text-sm font-medium text-zinc-300" data-id="element-83">
              "No se trata de comprar por comprar. Se trata de aprender a
              moverte."
            </p>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/gZ6FwWk8WBkmGak1URyC75/5.jpg" alt="iPhones sobre escritorio" loading="lazy" decoding="async" width="800" height="1000" className="absolute inset-0 w-full h-full object-cover" data-id="element-84" />
          <div className="absolute inset-0 bg-gradient-to-tr from-zinc-950/80 via-zinc-950/20 to-transparent" data-id="element-85"></div>
        </div>
      </div>
    </Section>;
};
export const CoursePillars = () => {
  return <Section className="bg-white/[0.02] border-y border-white/[0.05] backdrop-blur-sm" data-id="element-86">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-87">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-88">
          ¿Qué es Sistema iPhone Ads?
        </h2>
        <p className="text-lg text-zinc-400" data-id="element-89">
          Sistema iPhone Ads es una capacitación digital creada para personas
          que quieren empezar o mejorar su negocio de compra y venta de iPhones.
          Dentro del curso vas a aprender dos partes fundamentales:
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-90">
        <div className="bg-zinc-900/60 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-3xl overflow-hidden group hover:border-blue-500/50 transition-colors flex flex-col shadow-md md:shadow-xl" data-id="element-91">
          <div className="relative h-48 md:h-56 w-full overflow-hidden" data-id="element-92">
            <img src="https://images.unsplash.com/photo-1605236453806-6ff36851218e?q=80&w=800&fm=webp&auto=format&fit=crop" alt="Operación de negocio" loading="lazy" decoding="async" width="800" height="600" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-93" />
            <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-zinc-900/40 to-transparent" data-id="element-94"></div>
            <TrendingUp className="absolute bottom-4 left-8 w-10 h-10 text-blue-500 drop-shadow-lg" data-id="element-95" />
          </div>
          <div className="p-8 pt-4 relative" data-id="element-96">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-97">
              Negocio / Operación
            </h3>
            <p className="text-zinc-400 leading-relaxed" data-id="element-98">
              Nico te enseña cómo funciona el negocio de iPhones desde adentro:
              cómo empezar sin stock propio, cómo vender por pedido, cómo
              conseguir proveedores, cómo entender modelos, logística y cómo
              evitar comprar mal.
            </p>
          </div>
        </div>

        <div className="bg-zinc-900/60 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-3xl overflow-hidden group hover:border-emerald-500/50 transition-colors flex flex-col shadow-md md:shadow-xl" data-id="element-99">
          <div className="relative h-48 md:h-56 w-full overflow-hidden" data-id="element-100">
            <img src="https://images.unsplash.com/photo-1512428559087-560fa5ceab42?q=80&w=800&fm=webp&auto=format&fit=crop" alt="Marketing y Ventas" loading="lazy" decoding="async" width="800" height="600" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-101" />
            <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-zinc-900/60 to-zinc-900/20" data-id="element-102"></div>

            {/* Floating Tech Chips */}
            <div className="absolute inset-0 flex flex-wrap items-center justify-center gap-2 p-4" data-id="element-103">
              <span className="bg-zinc-950/90 backdrop-blur-sm md:backdrop-blur-md border border-zinc-700/50 shadow-md text-xs font-semibold text-zinc-200 px-3 py-1.5 rounded-full" data-id="element-104">
                Instagram
              </span>
              <span className="bg-zinc-950/90 backdrop-blur-sm md:backdrop-blur-md border border-zinc-700/50 shadow-md text-xs font-semibold text-zinc-200 px-3 py-1.5 rounded-full" data-id="element-105">
                WhatsApp
              </span>
              <span className="bg-zinc-950/90 backdrop-blur-sm md:backdrop-blur-md border border-zinc-700/50 shadow-md text-xs font-semibold text-zinc-200 px-3 py-1.5 rounded-full" data-id="element-106">
                Meta Ads
              </span>
              <span className="bg-zinc-950/90 backdrop-blur-sm md:backdrop-blur-md border border-zinc-700/50 shadow-md text-xs font-semibold text-zinc-200 px-3 py-1.5 rounded-full" data-id="element-107">
                Conversaciones
              </span>
            </div>
            <Users className="absolute bottom-4 left-8 w-10 h-10 text-emerald-500 drop-shadow-lg" data-id="element-108" />
          </div>
          <div className="p-8 pt-4 relative" data-id="element-109">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-110">
              Marketing / Ventas
            </h3>
            <p className="text-zinc-400 leading-relaxed" data-id="element-111">
              Damian te enseña cómo conseguir clientes usando contenido,
              Instagram, WhatsApp y Meta Ads, con una estrategia pensada para
              vender iPhones por conversación y no atraer solamente curiosos.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-16 text-center max-w-3xl mx-auto px-4" data-id="element-112">
        <div className="inline-block p-[1px] rounded-2xl bg-gradient-to-r from-white/[0.1] via-white/[0.05] to-white/[0.1] shadow-lg md:shadow-2xl" data-id="element-113">
          <div className="bg-zinc-950/80 backdrop-blur-md md:backdrop-blur-xl px-6 md:px-8 py-6 md:py-8 rounded-2xl" data-id="element-114">
            <p className="text-xl md:text-2xl font-bold text-white leading-relaxed" data-id="element-115">
              <span className="text-zinc-400 block mb-3 text-lg font-medium" data-id="element-116">
                No es un curso genérico de marketing.
              </span>
              Es negocio real de iPhones + captación de clientes por
              conversación.
            </p>
          </div>
        </div>
      </div>
    </Section>;
};
export const Instructors = () => {
  return <Section data-id="element-117">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-118">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-119">
          Quiénes te enseñan
        </h2>
      </div>
      <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-120">
        <div className="bg-zinc-900/50 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-3xl p-6 md:p-8 shadow-md md:shadow-xl" data-id="element-121">
          <div className="flex items-center mb-4" data-id="element-122">
            <div className="w-10 h-10 rounded-full bg-blue-500/10 flex items-center justify-center mr-3" data-id="element-123">
              <TrendingUp className="w-5 h-5 text-blue-500" data-id="element-124" />
            </div>
            <h3 className="text-xl font-bold text-white" data-id="element-125">Nico — Negocio</h3>
          </div>
          <p className="text-zinc-400 leading-relaxed" data-id="element-126">
            Nico te muestra la parte real del negocio de iPhones: cómo empezar
            sin stock propio, cómo vender por pedido, proveedores, modelos,
            logística, errores comunes al comprar y cómo ordenar el negocio paso
            a paso.
          </p>
        </div>
        <div className="bg-zinc-900/50 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-3xl p-6 md:p-8 shadow-md md:shadow-xl" data-id="element-127">
          <div className="flex items-center mb-4" data-id="element-128">
            <div className="w-10 h-10 rounded-full bg-emerald-500/10 flex items-center justify-center mr-3" data-id="element-129">
              <Users className="w-5 h-5 text-emerald-500" data-id="element-130" />
            </div>
            <h3 className="text-xl font-bold text-white" data-id="element-131">Damian — Marketing</h3>
          </div>
          <p className="text-zinc-400 leading-relaxed" data-id="element-132">
            Damian te muestra la parte de marketing y ventas: cómo conseguir
            clientes usando contenido, Instagram, WhatsApp, Meta Ads y
            conversaciones comerciales para vender iPhones sin atraer solamente
            curiosos.
          </p>
        </div>
      </div>
      <div className="mt-10 text-center max-w-2xl mx-auto" data-id="element-133">
        <p className="text-lg md:text-xl font-semibold text-blue-400" data-id="element-134">
          No es un curso genérico de marketing. Es negocio real de iPhones +
          captación de clientes por conversación.
        </p>
      </div>
    </Section>;
};